import { ServerCaseFilters } from "./casesApi";

export const initialFilters: ServerCaseFilters = {
  [ServerCaseFilters.AmazonCaseId]: "",
  [ServerCaseFilters.AmazonCaseCreatedDate]: "",
  [ServerCaseFilters.MonitoringDate]: "",
  [ServerCaseFilters.CurrentAction]: "",
  [ServerCaseFilters.CurrentCaseOwner]: "",
  [ServerCaseFilters.BackupCaseOwner]: "",
  [ServerCaseFilters.StoreName]: [],
  [ServerCaseFilters.VendorName]: [],
  [ServerCaseFilters.PresubmissionRequired]: "",
  [ServerCaseFilters.ParentInvoiceId]: [],
  [ServerCaseFilters.Processor]: "",
  [ServerCaseFilters.BackupProcessor]: "",
  [ServerCaseFilters.SubmissionPath]: "",
  [ServerCaseFilters.Stage]: "",
  [ServerCaseFilters.SprinterViewedAt]: "",
  [ServerCaseFilters.Sprinter]: "",
  [ServerCaseFilters.BackupSprinter]: "",
  [ServerCaseFilters.SubmissionAmount]: [],
  [ServerCaseFilters.SubmissionDate]: "",
  [ServerCaseFilters.RedFlags]: [],
  [ServerCaseFilters.CaseFilingUser]: "",
  [ServerCaseFilters.ManualFilingUser]: "",
  [ServerCaseFilters.CorrespondenceWorkFlags]: [],
  [ServerCaseFilters.VcDisputedInvoiceIds]: [],
};
